import { createContext } from 'react';
import { User } from '../types';

export interface AuthContextType {
  currentUser: User | null;
  login: (email: string, pass: string) => Promise<User>;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextType | null>(null);